import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
  },
  Counter: { display: 'flex', alignItems: 'center' },
  button: {
    background: theme.palette.grey[300],
    border: 8,
    width: 20,
    height: 20,
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 700,
    fontSize: 20,
    '& svg': {
      fontSize: 16
    }
  },
  countValue: {
    marginLeft: 12,
    marginRight: 12,
    fontSize: 18
  },
  label: {
    color: theme.palette.text.secondary
  },
  textContainer: {
    marginRight: 16
  }
}))

export default useStyles
